import { Component, inject, OnInit, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PaginatorModule } from 'primeng/paginator';
import {
  TableColumn,
  TableComponent,
} from '@app/shared/components/table/table.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  EstadoVagaEnum,
  Vaga,
  VagaListItemDTO,
  ProfissaoCatalogoListItemDTO,
} from '@app/features-modules/bolsa-de-profissionais/api';
import {
  VagaService,
  ProfissionalService,
  ProfissaoCatalogoService,
  EmpresaSectorService,
} from '@app/features-modules/bolsa-de-profissionais/services';
import { DialogService } from 'primeng/dynamicdialog';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { ApiService } from '@core/providers/http';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models/filterItem.model';
import { Pagination } from '@app/shared/model';
import { DialogModule } from 'primeng/dialog';
import { CadastrarVagasComponent } from '@app/features-modules/bolsa-de-profissionais/components/vagas/cadastrar-vagas/cadastrar-vagas.component';
import { SelectModule } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { AuthStore } from '@core/service/auth-store.service';
@Component({
  selector: 'app-lista-vagas',
  imports: [
    CommonModule,
    TableModule,
    Menu,
    ButtonModule,
    PaginatorModule,
    TableComponent,
    ConfirmDialogModule,
    DialogModule,
    SearchBarComponent,
    SelectModule,
    InputText,
    ReactiveFormsModule,
    DataVoidComponent,
  ],
  providers: [
    DialogService,
    ApiService,
    EmpresaSectorService,
    ProfissaoCatalogoService,
    ProfissionalService,
    VagaService,
    DataVoidComponent,
  ],
  template: `
    <div class="searchbar mb-3 w-full">
      <app-search-bar
        [showFilterBtn]="true"
        (onFilterBtnClick)="showFilter = true"
        [showPrimaryBtn]="false"
        (formValueChange)="handleFormValueChange($event)"
      ></app-search-bar>
    </div>

    <div class="row">
      @if (pagination.data?.length) {
        <app-table
          [pagination]="pagination"
          [columns]="columns"
          [actions]="actions"
          (pageChange)="onPageChange($event)"
        ></app-table>
      } @else {
        <div class="no-data">
          <app-data-void
            titulo="Nehuma vaga encontrada"
            descricao="Quando forem criadas vagas, ela aparecerão aqui"
          ></app-data-void>
        </div>
      }
    </div>
    <p-dialog
      header="Filtros"
      [modal]="true"
      [(visible)]="showFilter"
      [style]="{ width: '40rem' }"
      appendTo="body"
    >
      <form [formGroup]="form" class="p-fluid grid">
        <div
          *ngFor="let filter of filters"
          class="field col-6 d-flex flex-column"
        >
          <label>{{ filter.placeholder }}</label>

          <!-- Se for dropdown -->
          <p-select
            *ngIf="filter.type === 'dropdown'"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            [options]="filter.options"
            [formControlName]="filter.controlName"
            [placeholder]="filter.placeholder"
            [optionLabel]="filter.optionLabel"
            [optionValue]="filter.optionValue"
          >
          </p-select>

          <!-- Se for texto -->
          <input
            *ngIf="filter.type === 'text'"
            pInputText
            [formControlName]="filter.controlName"
            [placeholder]="filter.placeholder"
            class="w-full"
          />
        </div>
      </form>

      <div class="flex items-center justify-content-between">
        <p-button
          label="Cancelar"
          severity="secondary"
          (click)="showFilter = false"
        />
        <p-button
          label="Pesquisar"
          (click)="handleFormValueChange(form.value)"
        />
      </div>
    </p-dialog>
  `,
  styles: ``,
})
export class ListaVagasComponent {
  @Input('perfilEmpresa') perfilEmpresa: any;
  router = inject(Router);
  vagaService = inject(VagaService);
  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  confirmationService = inject(ConfirmationService);
  auth = inject(AuthStore);

  empresaService = inject(EmpresaSectorService);
  pagination: Pagination<Vaga> = new Pagination<Vaga>();

  profissionalService = inject(ProfissionalService);
  profissaoService = inject(ProfissaoCatalogoService);
  listaProfissoes: ProfissaoCatalogoListItemDTO[] = [];
  listaVagas: VagaListItemDTO[] = [];
  listaEmpresas: any[] = [];
  form!: FormGroup;
  vagaSelecionada: Vaga[] = [];
  estadoOption = [
    { id: EstadoVagaEnum.NUMBER_1, designacao: 'Aberto' },
    { id: EstadoVagaEnum.NUMBER_2, designacao: 'Fechado' },
    { id: EstadoVagaEnum.NUMBER_3, designacao: 'Cancelado' },
  ];
  sortFields: any[] = [
    { label: 'codigo', value: 'codigo' },
    { label: 'Profissão de referência', value: 'designacaoFuncao' },
  ];
  isLoading: boolean = false;
  showFilter: boolean = false;

  // pagination: Pagination<Vaga> = new Pagination<Vaga>();

  columns: TableColumn[] = [
    { field: 'codigo', header: 'Código função' },
    { field: 'designacaoFuncao', header: 'Função de Referência' },
    {
      field: 'numVaga',
      header: 'Vagas Disponíveis',
      type: 'badge',
      severityField: 'help',
    },
    {
      field: 'totalCandidaturas',
      header: 'Nº de candidaturas',
      type: 'badge',
      severityField: 'estadoVaga',
      badgeSeverityFunction: (rowData: any) =>
        rowData.estadoVaga === 'Aberto' ? 'info' : 'info',
    },
    {
      field: 'dataCricao',
      header: 'Data Criação ',
    },
    { field: 'dataEncerramento', header: 'Data Encerramento' },
    {
      field: 'estadoVaga',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoVaga',
      tagSeverityFunction: (rowData: any) =>
        rowData.estadoVaga === 'Aberto' ? 'success' : 'info',
    },
  ];

  actions: MenuItem[] = [
    {
      label: 'Ver Detalhes da Vaga',
      icon: 'pi pi-desktop',
      command: ($event) => this.detalhesVaga($event as any),
    },
    // {
    //   label: 'Ver Candidatos',
    //   icon: 'pi pi-user',
    // },
    // {
    //   label: 'Editar vaga',
    //   icon: 'pi pi-pencil',
    //   command: () => this.editarVaga(),
    // },
    {
      label: 'Gerar Comprovativo',
      icon: 'pi pi-file-pdf',
      command: ($event) => this.onGerarComprovativo($event as any),
    },
    // {
    //   label: 'Eliminar Vaga',
    //   icon: 'pi pi-trash',
    // },
  ];

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'ProfissaoCatalogoID',
      placeholder: 'Pesquise a profissão catálogo',
      options: this.listaProfissoes,
      optionLabel: 'designacaoISCO',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EmpresaID',
      placeholder: 'Pesquise pela empresa',
      options: this.listaEmpresas,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoVaga',
      placeholder: 'Estado',
      options: this.estadoOption,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];
  @ViewChild(ListaVagasComponent) childComponent!: ListaVagasComponent;

  cadastrarVaga() {
    // this.router.navigate(['vagas/cadastrar'])
    console.log('cadastrar', this.childComponent);
    const ref = this.dialogService.open(CadastrarVagasComponent, {
      showHeader: false,
      width: '50%',
      modal: true,
    });

    ref.onClose.subscribe((data) => {
      // this.childComponent.getAllVagas();
      this.getAllVagas();
      if (data.refresh) {
        console.log('Form submitted:', data);
      }
    });
  }

  constructor(private fb: FormBuilder) {}

  onGerarComprovativo(event: any) {
    const vagaId = event?.item?.data?.id ?? event?.data?.id;
    if (!vagaId) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Não foi possível identificar a vaga.',
        life: 3000,
      });
      return;
    }

    this.isLoading = true;
    this.profissionalService.gerarComprovativo({ VagaId: vagaId }).subscribe({
      next: (blob) => {
        this.isLoading = false;

        const filename = `comprovativo-vaga-${vagaId}.pdf`;
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);

        this.messageService.add({
          severity: 'success',
          summary: 'Comprovativo',
          detail: 'Comprovativo gerado com sucesso.',
          life: 3000,
        });
      },
      error: (err) => {
        this.isLoading = false;
        console.error('gerarComprovativo error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Falha ao gerar comprovativo.',
          life: 4000,
        });
      },
    });
  }

  ngOnInit() {
    this.getAllVagas();
    this.getProfissoes();
    this.getAllEmpresas();
    this.form = this.fb.group({
      ProfissaoCatalogoID: [null],
      EmpresaID: [null],
      EstadoVaga: [null],
    });
  }

  getProfissoes() {
    this.profissaoService.list().subscribe((result) => {
      if (result.data) {
        this.listaProfissoes = result.data;
        this.filters[0].options = this.listaProfissoes.map((profissao) => ({
          ...profissao,
          designacaoISCO: `${profissao.codigoISCO} - ${profissao.designacaoISCO}`,
        }));
      }
    });
  }

  getAllEmpresas(filters?: any) {
    const params = {
      pageNumber: 1,
      pageSize: 100,
      ...filters,
    };
    this.empresaService.list(params).subscribe(
      (res: any) => {
        this.listaEmpresas = res.data;
        this.filters[1].options = this.listaEmpresas;
      },
      (error: any) => {
        console.error('Erro ao buscar empresas:', error);
      },
    );
  }

  handleFormValueChange(event: any) {
    const queryParams = Object.fromEntries(
      Object.entries(event).filter(
        ([key, value]) => value !== null && value !== '',
      ),
    );
    this.getAllVagas(queryParams);
  }

  getAllVagas(queryParams?: any) {
    console.log(this.perfilEmpresa, 'perfilEmpresa');
    this.isLoading = true; // Iniciar carregamento
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      EmpresaID: this.perfilEmpresa?.id,
      OrderBy: 'id desc',
    };
    this.vagaService.list(params).subscribe(
      (response) => {
        console.log('Vagas', response);
        this.pagination = new Pagination<any>().deserialize(response);

        this.isLoading = false;
      },
      (error) => {
        console.error('Erro ao buscar vagas:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar vagas.',
          life: 3000,
        });
        this.isLoading = false;
      },
    );
  }

  detalhesVaga(event: any): void {
    if (this.auth.hasAny(['Consultar_Vagas_Emprego'])) {
      this.router.navigate([
        `/bolsa-profissionais/vagas/detalhe-vaga/${event?.id}`,
        {
          queryParams: { empresaID: this.perfilEmpresa?.id },
        },
      ]);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  editarVaga() {}

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllVagas();
  }

  trackById(index: number, item: Vaga) {
    return item.id;
  }
}
